module.exports = __webpack_public_path__ + "static/media/no.fc029595.svg";